import { pricing } from './pricing';
import { invoices } from './invoices';

export const billingArticles = [
  pricing,
  invoices
]; 